import React from "react";
import DesktopFooter from "./desktop";
import MobileFooter from "./mobile";

const FooterWrapper = ({ context, pageSettings }) => (
	<>
		 <DesktopFooter
			data={context}
			hideNewsletter={pageSettings?.hideNewsletter}
			hideReferAFriend={pageSettings?.hideReferAFriend}
		/>
		<MobileFooter
			data={context}
			hideNewsletter={pageSettings?.hideNewsletter}
			hideReferAFriend={pageSettings?.hideReferAFriend}
		/> 
	</>
);

export default FooterWrapper;
